import React from 'react'

import { Skeleton } from '@/shared/components/atoms/Skeleton'
import { Card, CardContent } from '@/shared/components/molecules/Card/Card'

import { SKELETON_ITEMS_COUNT } from './Users.constants'

/**
 * Loading skeleton for users list
 */
export const UsersSkeleton: React.FC = () => {
	return (
		<div className="space-y-6">
			<Card>
				<CardContent className="p-0">
					<div className="divide-y">
						{Array.from({ length: SKELETON_ITEMS_COUNT }).map((_, index) => (
							<div key={index} className="p-6">
								<div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
									{/* Mobile layout - username and dropdown on same row */}
									<div className="flex items-center justify-between lg:hidden">
										<Skeleton className="h-5 w-32" />
										<Skeleton className="h-8 w-8 rounded" />
									</div>

									{/* Desktop layout - username only */}
									<div className="hidden lg:block">
										<Skeleton className="h-5 w-48" />
									</div>

									{/* User details */}
									<div className="flex flex-col lg:flex-row lg:items-center gap-2">
										<Skeleton className="h-3 lg:h-4 w-32 lg:w-40" />
										{/* Mobile badge */}
										<Skeleton className="lg:hidden h-5 w-20" />
										<Skeleton className="hidden lg:block h-4 w-1" />
										<Skeleton className="h-3 lg:h-4 w-24 lg:w-32" />
									</div>

									{/* Desktop badge and dropdown */}
									<div className="hidden lg:flex items-center gap-3">
										<Skeleton className="h-6 w-20" />
										<Skeleton className="h-8 w-8 rounded" />
									</div>
								</div>
							</div>
						))}
					</div>
				</CardContent>
			</Card>
		</div>
	)
}
